import React from "react";
import { Card, Progress, Tag, Button } from "antd";
import { CalendarOutlined } from "@ant-design/icons";


const CourseProgressCard = ({ title, date, percent, showProgress = true }) => 
  {
  const getStatusFromPercent = (percent, showProgress) => {
    if (!showProgress) return "Enrolled";     
    if (percent >= 100) return "Completed";     
    if (percent > 0) return "In Progress";      
    return "Not Started";   
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "In Progress":
        return "blue";
      case "Completed":
        return "green";
      case "Enrolled":
        return "default";
      default:
        return "gray";
    }
  };

  const displayStatus = getStatusFromPercent(percent, showProgress);
  const displayButton =
  percent >= 100 ? "View Certificate" : "Continue Course";


  return (
    <div className="h-full overflow-x-scroll xl:overflow-x-hidden mb-2">
        <Card className="rounded-2xl">
          <div className="flex justify-between items-start">
            <div>
              <h3 className="text-base font-semibold text-gray-900">
                {title}
              </h3>

              <div className="flex items-center text-gray-700 text-sm mt-1">
                <CalendarOutlined className="mr-1" />
                {date}
              </div>
            </div>

            <Tag
              color={getStatusColor(displayStatus)}
              className="rounded-full px-3 py-1 text-xs font-medium"
            >
              {displayStatus}
            </Tag>
          </div>

          {showProgress && (
            <div>
              <p className="text-sm text-gray-700">
                Progress
              </p>

              <div className="flex items-center">
                <Progress
                  percent={percent}
                  showInfo={false}
                  strokeColor={{
                    from: "#a855f7",
                    to: "#1ab541ff",
                  }}
                  className="flex-1"
                />
                <span className="text-sm font-semibold text-purple-600 ml-2">
                  {percent}%
                </span>
              </div>

            </div>
          )}  
          <Button
            block
            type="default"
            className="mt-2 rounded-xl border-gray-200 text-gray-700 font-medium hover:bg-gray-50"
          >
            {displayButton}
          </Button>
        </Card>
    </div>
  );
};

export default CourseProgressCard;
